import { CreateSaleInfoRequest, SaleInfoResponse } from "../model/SaleInfoModel";
import { PageResponse } from "../../applications/constants/AppTypes";
import { ApiClient } from "../api/ApiClient";

const BASE_URL = "/api/sale-infor";
class SaleInfoServiceClass {
  getAllSaleInfo(page: number, limit: number, is_sale_order?: boolean, is_active?: boolean) {
    return ApiClient.get<PageResponse<SaleInfoResponse[]>>(BASE_URL + "/all", {
      params: {
        page,
        limit,
        is_sale_order,
        is_active,
      },
    });
  }

  createNewSale(request: CreateSaleInfoRequest, thumbnailImage?: File) {
    const formData = new FormData();
    if (thumbnailImage) {
      formData.append("files", thumbnailImage, thumbnailImage.name);
    }
    formData.append("request", JSON.stringify(request));
    return ApiClient.post<SaleInfoResponse>(BASE_URL + "/create", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  updateSale(request: CreateSaleInfoRequest & { id: number; thumbnailImage?: File }) {
    const formData = new FormData();
    if (request?.thumbnailImage) {
      formData.append("files", request.thumbnailImage, request.thumbnailImage.name);
    }
    const { id, thumbnailImage, ...bodyRequest } = request;
    formData.append("request", JSON.stringify(bodyRequest));
    return ApiClient.put<SaleInfoResponse>(BASE_URL + `/update/${request.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  deleteSale(id: number) {
    return ApiClient.delete(BASE_URL + `/delete/${id}`);
  }

  enableActive(id: number, status: boolean) {
    return ApiClient.put(BASE_URL + `/update/${id}/enable-active?is_active=${status}`);
  }
}
export const SaleInfoService = new SaleInfoServiceClass();
